import React, { useState, useRef } from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Alert, Button, Form } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';

const ConversonOrPenaltySetClip = (props) => {

    const { homeTeam, awayTeam, startTeamId, homeTeamPlayers,awayTeamPlayers, onCancelButtonClick , realMarkerX, realMarkerY, clipSelected, setClip} = props;
    const [selectedPlayer, setSelectedPlayer] = useState(`${clipSelected?.shirtNumber || clipSelected?.playerShirtNumber || ''}`);
    const [scoreErrorMessages, setScoreErrorMessages] = useState(null);
    const [errorInputIds, setErrorInputIds] = useState(null);
    const dropdownSelectPlayerRef = useRef(null);
    let markerX = realMarkerX ? realMarkerX : clipSelected.positionX;
    let markerY = realMarkerY ? realMarkerY : clipSelected.positionY;

    const getScoreErrorMessageSpan = () => {
        if (scoreErrorMessages && scoreErrorMessages.length > 0) {

            let result = [];

            for (let i = 0; i < scoreErrorMessages.length; i++) {
                let current = scoreErrorMessages[i];
                result.push(
                    <Alert key={current.id} variant="danger" className="text-center my-1" onClose={() => {
                        setScoreErrorMessages(scoreErrorMessages && scoreErrorMessages.length > 0 ? scoreErrorMessages.filter((x) => x.id != current.id) : null);
                        setErrorInputIds(errorInputIds && errorInputIds.length > 0 ? errorInputIds.filter((x) => x != current.id) : null);
                    }} dismissible>
                        <span>{current.text}</span>
                    </Alert>);
            }

            return <div className="mb-1" style={{ maxHeight: '240px', overflowY: 'scroll' }}>{result}</div>;
        }
    }

    const scoreErrorMessageSpan = getScoreErrorMessageSpan();

        return <>

        <div className="col-md-12 text-center">
            <h3> Try </h3> 

            <Row>
                <Col>
                    <div className="d-flex">
                        <span className="py-1"> <b>Team: &nbsp; </b></span>
                        <span className="py-1">{startTeamId == homeTeam.id ? homeTeam.name : awayTeam.name }</span>
                    </div>
                </Col>
            </Row>
            <Row className="pt-2">
                <Col>
                    <div className="d-flex">
                        <span className="py-1"><b>Select Try Scorer:</b></span>
                        <Form.Control as="select"
                            size="sm"
                            ref={dropdownSelectPlayerRef}
                            value={selectedPlayer}
                            onChange={(event) => { 
                                setSelectedPlayer(event.target.value);
                            }}
                            className="ml-1"
                            style={{ width: '175px' }}
                            autoFocus
                        >
                            <option key="" value="">Please select try scorer...</option>
                            {(startTeamId === homeTeam.id ? homeTeamPlayers : awayTeamPlayers)
                                ?.filter(x => x.shirtNumber)
                                .map(x => {
                                    return <option key={x.shirtNumber} value={x.shirtNumber}>{x.key}</option>
                                })
                            }
                        </Form.Control>
                    </div>
                </Col>
            </Row>
            <Row style={{ marginTop : '2rem'}}>
                <Col>
                    <div className="col-md-12 text-center">
                        <Button variant="danger"
                            onClick={async (e) => {
                                await onCancelButtonClick(e);
                            }}>Cancel</Button>
                    </div>
                </Col>
                <Col>
                    <div className="col-md-12 text-center">
                        <Button variant="success"
                            onClick={async () => {
                                if (!selectedPlayer) {
                                    setScoreErrorMessages([{ id: uuidv4(), text: "Please select a player" }]);
                                    return;
                                }
                                await setClip(clipSelected.id, markerX, markerY, clipSelected.type, clipSelected.teamId, selectedPlayer );
                            }}>Confirm Update Clip</Button>
                    </div>
                </Col>
            </Row>
        </div>
        {scoreErrorMessageSpan}
    </>;
}

export default ConversonOrPenaltySetClip;